import clsx from "clsx";
import { ClockIcon, StarIcon } from "lucide-react";

import { Badge } from "@/components/ui/badge";

import { dates } from "@/lib/dates";
import { misc } from "@/lib/misc";
import { FlatCandidacyWithProfileResponse } from "@/types";

export const JobPipelineKanbanCard = (
  props: FlatCandidacyWithProfileResponse,
) => {
  const daysAgo = dates.calculateDaysAgo(props.timeInStage);

  return (
    <div className="rounded-lg border border-slate-200 p-4">
      <div className="flex flex-col items-start gap-2">
        <div className="flex w-full items-center justify-between">
          <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-primary-900">
            <p className="text-sm font-medium text-white">
              {misc.toTitleCase(props.candidateProfileFirstName?.[0] ?? "")}
              {misc.toTitleCase(props.candidateProfileLastName?.[0] ?? "")}
            </p>
          </div>
          <div className="flex items-center gap-1">
            <StarIcon
              className={clsx(
                "h-4 w-4",
                props.candidacyScore
                  ? "fill-yellow-500 text-yellow-500"
                  : "fill-slate-300 text-slate-300",
              )}
            />
            <p className="text-sm font-medium text-slate-700">
              {/* eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing */}
              {props.candidacyScore || "-"}/5
            </p>
          </div>
        </div>
        <div className="flex flex-col">
          <p className="text-base font-medium text-slate-700">
            {misc.toTitleCase(
              `${props.candidateProfileFirstName ?? ""} ${
                props.candidateProfileLastName ?? ""
              }`,
            )}
          </p>
          <p className="text-sm font-medium text-slate-500">
            {props.candidateProfileDesiredPosition}
          </p>
        </div>
        <Badge
          className={clsx(
            "flex items-center gap-1",
            daysAgo < 3
              ? "bg-slate-50"
              : daysAgo < 7
                ? "border border-yellow-400 bg-yellow-100"
                : "border border-red-300 bg-red-100",
          )}
          variant="outline"
        >
          <ClockIcon className="h-4 w-4" />
          {dates.timeAgoForPipelineKanbanCard(props.timeInStage)}
        </Badge>
      </div>
    </div>
  );
};
